/// <reference path="../../Common/Helpers/GridEditorBase.ts" />


namespace RioERP.Orders {
    
    @Serenity.Decorators.registerEditor()
    export class OrderInstallmentEditor extends Common.GridEditorBase<OrderInstallmentsRow> {
        protected getColumnsKey() { return 'Orders.OrderInstallments'; }
        protected getDialogType() { return OrderInstallmentsEditDialog; }

        protected getLocalTextPrefix() { return OrderInstallmentsRow.localTextPrefix; }
        public stateid: number;

        constructor(container: JQuery) {
            super(container);
        }

        protected getAddButtonCaption() {
            return "Add";   
        }

        protected initEntityDialog(itemType: string, dialog: Serenity.Widget<any>) {
            super.initEntityDialog(itemType, dialog);
            //debugger;
            // passing discount from grid editor to detail dialog
            (dialog as OrderInstallmentsEditDialog).stateIds = this.stateid;
        }
        protected getQuickFilters() {

            var filters = super.getQuickFilters();
            filters.splice(Q.indexOf(filters, x => x.field == "OrderSourceType"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderIsEmailSent"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderFranchiseeId"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderShippingStatus"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderId"), 1);


            return filters;

        }

        //validateEntity(row, id) {
        //    row.OrderId = Q.toId(row.OrderId);

        //    var sameProduct = Q.tryFirst(this.view.getItems(), x => x.OrderId === row.OrderId);
        //    if (sameProduct && this.id(sameProduct) !== id) {
        //        Q.alert('This Order is already added!');
        //        return false;
        //    }           
        //    return true;
        //}
    }
}